import React from 'react';

export const BackdropSvg = props => {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 265 220"
            className={props.className}
            style={props.style}
        >
            <g id="Page-1">
                <g id="Home">
                <path
                    id="Fill-1"
                    fill={props.fill || '#ffffff'}
                    d="M131.2,219.1c-80.3,0-95.5-4.8-122.3-12.2-4.8-1.3-8.8-6.4-8.8-11.3V9C0,4,4,0,9,0h246.2c5,0,9,4,9,9v186.6c0,5-4,10-8.8,11.3-26.8,7.4-42,12.2-122.3,12.2h-1.8Z"
                />
                </g>
            </g>
            </svg>
    )
};

export default BackdropSvg;


// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/BackdropSvg.js